import { Modal as BootstrapModal } from 'react-bootstrap'

import { Modal } from '../../components/Modal/Modal'

import { useDocumentLeaveBlocker } from './hooks'

export const DocumentLeaveGuard: React.FC = () => {
  const { showModal, confirmLeave, cancelLeave, isBatch } = useDocumentLeaveBlocker()

  return <DocumentLeaveConfirmationModal show={showModal} onConfirm={confirmLeave} onCancel={cancelLeave} isBatch={isBatch} />
}

interface DocumentLeaveConfirmationModalProps {
  show: boolean
  onConfirm: () => void
  onCancel: () => void
  isBatch: boolean
}

const DocumentLeaveConfirmationModal: React.FC<DocumentLeaveConfirmationModalProps> = ({ show, onConfirm, onCancel, isBatch }) => {
  return (
    <Modal
      show={show}
      onHide={onCancel}
      header={<BootstrapModal.Title>Zero data retention is set</BootstrapModal.Title>}
      headerBodySeparator={true}
      bodyClassName='zocks-pb-0.75'
      body={
        <span>
          Your account has zero data retention policy for documents, so Zocks doesn't store any of them. By leaving the {isBatch ? 'package' : 'document'} all
          unsynced insights will be lost.
        </span>
      }
      footerClassName='zocks-pt-0.75 zocks-px-1.5 zocks-pb-1.5'
      showFooterActions={true}
      onFooterPrimaryAction={onConfirm}
      footerPrimaryActionTitle={isBatch ? 'Leave package' : 'Leave document'}
      footerPrimaryActionButtonVariant='danger'
    />
  )
}
